// extracted by mini-css-extract-plugin
module.exports = {"deliveries_list__grid":"deliveries_list__grid"};